module.exports = __webpack_public_path__ + "bafc1333fbed93b682a465e13db70d88.svg";